import { CodeAndLabel } from './../../../integrated-client/models/CodeAndLabel';
import {
  GuidIdAndLabel,
  BrandAndMarketListItem
} from '../../../integrated-client/models/';
import { DEFAULT_LIMIT } from '../SearchManager/FormData';
import {DEFAULT_TOTAL_ITEMS} from "../../../utils/Constants";

export interface IAutocompleteObject {
  id: string;
  code: string;
  label: string;
}

export class AutocompleteObject implements IAutocompleteObject {
  id: string;
  code: string;
  label: string;

  constructor() {
    this.id = '';
    this.code = '';
    this.label = '';
  }
}

export interface FormData {
  showDeleted: boolean;
  showDisabled: boolean;
  brandAndMarket?: BrandAndMarketListItem | null;
  supplier: GuidIdAndLabel | null;
  carrier: CodeAndLabel | null;
  offset: number | null;
  limit: number | null;
  total: number;
  currentPage: number;
  relevance: number | null;
}

export class FormData implements FormData {
  showDeleted: boolean;
  showDisabled: boolean;
  brandAndMarket?: BrandAndMarketListItem | null;
  supplier: GuidIdAndLabel | null;
  carrier: CodeAndLabel | null;
  offset: number | null;
  limit: number | null;
  total: number;
  currentPage: number;
  relevance: number | null;

  constructor() {
    this.showDeleted = false;
    this.showDisabled = false;
    this.brandAndMarket = null;
    this.supplier = null;
    this.carrier = null;
    this.offset = 0;
    this.limit = DEFAULT_LIMIT;
    this.total = DEFAULT_TOTAL_ITEMS;
    this.currentPage = 1;
    this.relevance = null;
  }
}
